// src/utils/perfilUtils.js
//
// Fonte única de verdade para "quem pode ser responsável por questões"
// (papel funcional de articulador). Um ARTICULADOR sempre conta; um
// ADM.ORG só conta quando optou explicitamente por também atuar como
// articulador (campo `atuaComoArticulador`).

// Perfis que devem entrar na query ampla do Firestore (usada tanto para
// resolver nomes de responsáveis históricos quanto para montar a lista de
// quem pode ser atribuído). O filtro fino por `atuaComoArticulador` é
// aplicado depois, em memória, com isResponsavelFuncional.
export const PERFIS_RESPONSAVEIS = ['ARTICULADOR', 'ADM.ORG'];

export const isResponsavelFuncional = (userData) => {
  if (!userData) return false;
  const perfil = String(userData.perfil || '').trim().toUpperCase();
  if (perfil === 'ARTICULADOR') return true;
  if (perfil === 'ADM.ORG') return userData.atuaComoArticulador === true;
  return false;
};

// Fonte única de verdade para "quem pode votar na Priorização Colegiada"
// (membros do colegiado / Alta Gestão). Um usuário com perfil ALTA GESTAO
// sempre é membro; um ADM.ORG ou ARTICULADOR conta quando optou explicitamente
// por também atuar como membro do colegiado (campo `atuaComoGestor`).
export const PERFIS_GESTAO_COLEGIADA = ['ALTA GESTAO', 'ADM.ORG', 'ARTICULADOR'];

export const isMembroColegiado = (userData) => {
  if (!userData) return false;
  const perfil = String(userData.perfil || '').trim().toUpperCase();
  if (perfil === 'ALTA GESTAO') return true;
  if (perfil === 'ADM.ORG' || perfil === 'ARTICULADOR') return userData.atuaComoGestor === true;
  return false;
};
